export default "__VITE_ASSET__DH6sWw6Z__"